module.exports = __webpack_public_path__ + "media/images/powerpoint/ipsos-background-679a9fb04abc079ad2d795bb70f7230b.png";